import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import styled from 'styled-components';
import { LoadingKey } from './LoadingKey';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLoadingTitle = styled.h4.withConfig({
  displayName: "LoadingTitle__StyledLoadingTitle",
  componentId: "m7guwz-0"
})(["", ";"], props => props.loadingKey === LoadingKey.ACQ142SignupRequest && `
      text-align: center;
      width: 350px;
    `);
export const LoadingTitle = ({
  title,
  loadingKey
}) => {
  return /*#__PURE__*/_jsx(AnimatedStepBody, {
    children: /*#__PURE__*/_jsx(StyledLoadingTitle, {
      loadingKey: loadingKey,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: title
      })
    })
  }, title);
};